var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.taskInProgress)?_c('a-menu-item',{staticClass:"px-5 page-menu--item-height"},[_c('a-icon',{attrs:{"spin":"","type":"sync"}}),_vm._v(": "+_vm._s(_vm.taskInProgress)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }